<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text8.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="right-filter" style="width: 830px; height: 65px; ">
				<el-form :inline="true" :model="form">
					<el-form-item label="反馈状态:">
						<el-select v-model="form.state" placeholder="反馈状态" clearable>
							<el-option :label="item.label" :value="item.value" :key="item.value" v-for='item in types'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<div class="feedback_button" @click="getFeedback">
							<img src="@/images/zy_button.png" class="feedback_back" />
							<span>查询</span>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div v-if="!datalist || datalist.length<=0" class="simulation_empty_msg_content">暂无反馈</div>
			<div class="clearfix zy_postmain" v-if="datalist && datalist.length>0">
				<div class="zy_post_item zy_post_itembig" v-for="(item,index) in datalist" @click="openView(item)">
					<div class="zy_post_itemP1">
						<img src="@/images/zy_point_l.png" class="zy_postpoint" /> {{item.type}}
						<img src="@/images/is_over.png" v-if="item.state == 0" class="zy_is_over"/>
						<img src="@/images/is_overed.png" v-if="item.state == 1"  class="zy_is_over"/>
					</div>
					<div class="zy_post_itemP2 text-ellipsis">
						{{item.description || '暂无描述'}}
					</div>
					<div class="zy_post_itemP3">
						<span class="l">提交时间：{{item.createTime | spliceForTask }}</span>
					</div>
				</div>
			</div>
			<div class="table-page" v-if='datalist.length>0'>
				<el-pagination @current-change='pageChange' background layout="prev, pager, next" :page='page' :total="totalrow">
				</el-pagination>
			</div>
		</div>
		<div class="feedback" v-show='viewDialog'>
			<div class="feedback_cont">
				<i class="feedback_close el-icon-close" @click="viewDialog = false"></i>
				<el-form :model="form" ref='addform'>
					<div class="feedback_title">{{viewInfo.type}}</div>
					<div class="feedback_desc">感谢您对我们提出宝贵的意见和建议</div>
					<div class="feedback_item">
						<div class="feedback_label">反馈内容：</div>
						<el-form-item prop='description'>
							<div class="feedback_input">
								<div class="feedback_textare">
									<textarea v-model='viewInfo.description' readonly="readonly" placeholder="您的意见或建议"></textarea>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="feedback_item">
						<div class="feedback_label">反馈时间：</div>
						<el-form-item prop='contact'>
							<div class="feedback_input">
								<div class="feedback_text">
									<input type="text" v-model='viewInfo.createTime' readonly="readonly" placeholder="反馈时间" />
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="feedback_item" v-show="viewInfo.reply">
						<div class="feedback_label">回复内容：</div>
						<el-form-item prop='description'>
							<div class="feedback_input">
								<div class="feedback_textare">
									<textarea v-model='viewInfo.reply' readonly="readonly"></textarea>
								</div>
							</div>
						</el-form-item>
					</div>
				</el-form>
				<div class="feedback_buttons">
					<div class="feedback_button" @click="viewDialog = false">
						<img src="@/images/zy_button.png" class="feedback_back" />
						<span>确定</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getMyCoupleBack } from '@/api/feedback.js'
	import { spliceForTask } from '@/filters/index.js'
	export default {
		data() {
			return {
				form: {
					state: '',
				},
				types: [{
					value: '0',
					label: '待处理'
				}, {
					value: '1',
					label: '已处理'
				}],
				datalist: [],
				page: 1,
				pageSize: 10,
				totalrow: 0,
				viewDialog: false,
				viewInfo: {},
			}
		},
		created() {
			this.getFeedback();
		},
		methods: {
			openView(item) {
				this.viewInfo = item;
				this.viewInfo.createTime = spliceForTask(item.createTime)
				this.viewDialog = true;
			},
			pageChange(page) {
				this.page = page;
				this.getFeedback();
			},
			getFeedback() {
				var state = this.form.state;
				if(state == '') {
					state = null
				}
				var data = {
					pageSize: this.pageSize,
					page: this.page,
					state: state,
				}
				getMyCoupleBack(data).then(res => {
					if(res.code == 0) {
						const {
							data
						} = res;
						this.datalist = res.data.listData;
						this.totalrow = res.data.totalRow;
					}
				})
			},
		}
	}
</script>

<style>

</style>